import { Box, Button, Group } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"

interface Props {
  show?: boolean
  // we want any here because the component just stringifies the remaining props of any type

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export function Debug({ _show, ...props }: Props) {
  const [opened, { toggle }] = useDisclosure(_show || false)

  if (import.meta.env.PROD) {
    return null
  }

  return (
    <Box mt="xl">
      {_show ? null : (
        <Group justify="end" align="end" mb={5}>
          <Button size="xs" variant="default" onClick={toggle}>
            Debug Data
          </Button>
        </Group>
      )}
      {_show || opened ? <pre>{JSON.stringify(props, null, 2)} </pre> : null}
    </Box>
  )
}
